import {useCallback, useContext, useState} from "react";
import {PreviewDataContext} from "../context/PreviewContext";
import {InvoiceContext} from "../context/InvoiceContext";
import {OptionContext} from "../context/OptionContext";
import {PageContext} from "../context/PageContext";
import {ToastService} from "../service/ToastService";
import {CONSTANTS} from "../common/constants";

export function usePayNow() {
    const previewContext = useContext(PreviewDataContext);
    const invoice = useContext(InvoiceContext);
    const optionContext = useContext(OptionContext);
    const pageContext = useContext(PageContext);
    const [isPaymentModalVisible, setPaymentModalVisible] = useState<boolean>(false);

    const onClickPayNow = useCallback(() => {
        if (previewContext.isPreviewMode) {
            ToastService.middleScreenWarningToast('This button is not available in preview mode.');
            return;
        }
        if (!optionContext.selectedOption) {
            ToastService.middleScreenWarningToast(CONSTANTS.NO_SELECTED_OPTION_TOAST_WARNING_TEXT);
            return;
        }
        if (invoice.is_signature_available) {
            pageContext.setPaymentAcceptedSignatureMode(true);
        } else {
            setPaymentModalVisible(true);
        }
    }, [previewContext.isPreviewMode, optionContext.selectedOption, invoice.is_signature_available, pageContext]);

    const closePaymentModal = useCallback(() => {
        setPaymentModalVisible(false);
    }, []);

    return {onClickPayNow, isPaymentModalVisible, closePaymentModal};
}
